import Formsy from 'formsy-react';
import React from 'react'
import {useEffect, useRef, useState} from 'react';
import {Form, Grid, Dimmer, Loader, Search, Icon, Button} from 'semantic-ui-react';
import {form} from 'formsy-semantic-ui-react';
import DGTextbox from '../../../components/FormControls/Textbox/DGTextbox';
import DGSelect from '../../../components/FormControls/Select/DGSelect';
import { withRouter } from 'react-router';
import { format , normalize} from 'react-phone-input-auto-format'
import {createSellerCustomerRequest, getSellerCustomerSearch} from '../../../services/Seller';
import {getSCServicesList} from '../../../services/Services';

import './CreateCustomerRequestContainer.less';
import { isValidCellNumber } from '../../../helpers/validation';
import {NavigationUrls} from '../../../constants/NavigationUrls'

function CreateCustomerRequestContainer({history}) {

    const formRef = useRef(null);
    const [selectedCustomerId , setSelectedCustomerId] = useState(undefined);
    const [customerName, setCustomerName] = useState(undefined)
    const [showLoader, setLoader] = useState(false);
    const [servicesOptionState, setServicesOptionState] = useState([]);
    const [selectedServiceState,setSelectedServiceState] = useState(undefined);
    const [errorOnServiceSelection,SetErrorOnServiceSelection] = useState(false);
    const [customerSearchQuery , setCustomerSearchQuery] = useState("");
    const [customerSearchResult , setCustomerSearchResult] = useState([]);
    const [customerData , setCustomerData] = useState([]);
    const [errorOnPhoneField,setErrorOnPhoneField] = useState(false);
    const [phoneFieldErrorMeg,setPhoneFieldErrorMeg] = useState("");
    // const [customerNameKey , setCustomerNameKey] = useState(0);
    const [customerSelected,setCustomerSelected] = useState(false);


    useEffect(() => {
        getSCServicesList().then((res) => {
            console.log("res", res);
            if(res.resStatus == 200)
            {
                setServicesOptionState(res.data.map((ser) => {
                    return {
                        key: ser.scServiceID,
                        value: ser.scServiceID,
                        text: ser.name,
                    }      
                }))
                if(res.data && res.data.length == 1 )
                {
                    setSelectedServiceState(res.data[0].scServiceID)
                }
            }
        });
    } , [])

    const onSubmit = (form) =>{
        try {
            displayLoader();

            let InValidForm = false;
            if(selectedServiceState == undefined)
            {
                SetErrorOnServiceSelection(true);
                InValidForm = true;
            }
            if(!validatePhoneField())
            {
                InValidForm = true;
            }   
            
            if(InValidForm)
            {
                return;    
            }

            createSellerCustomerRequest({
                customerName: customerName,
                cellPhone: normalize(customerSearchQuery),
                scServiceID: selectedServiceState,
                customerID : selectedCustomerId
            }).then(res => {
                if(res.resStatus >= 400)
                {
                    console.log(res.message);
                }else
                {
                    resetForm();
                    if(res.data.requestToken)
                    {
                        history.push(`/customer/request/form/${res.data.requestToken}`); 
                    }else
                    {
                        history.push(`/`); 
                    }
                }
            })  
        }
        catch (ex) { 
            console.log(ex);
        }
        finally {
            hideLoader();
        }
    }


    const onPhoneKeyDown = (evt) => {
        if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
            var patt = new RegExp(/^[0-9\b]+$/);
            var res = patt.test(evt.key);
            if (!res)
                evt.preventDefault()
        }
    }

    const displayLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        setLoader(true);
    }

    const hideLoader = () => {
        document.body.style.overflowY = 'unset'
        setLoader(false);
    }

    const handleServiceSelection = (e, data) => {
        if(data && data.value)
        {
            setSelectedServiceState(data.value)
            SetErrorOnServiceSelection(false)
        }    
    }

    const onInvalidSubmit = () => {
        if(selectedServiceState == undefined)
        {
            SetErrorOnServiceSelection(true);  
        }
        validatePhoneField();
    }

    const validatePhoneField = (value = customerSearchQuery) => {
        let isValid = 0;
        if(value.length == 0)
        {
            setErrorOnPhoneField(true)
            setPhoneFieldErrorMeg("Phone Number is required")
            isValid = 0;
        } else
        {
            setErrorOnPhoneField(false);
            setPhoneFieldErrorMeg("");
            isValid = 1;
        }  
        
        if(isValid)
        {
            if(!isValidCellNumber("" ,value))
            {
                setErrorOnPhoneField(true)
                setPhoneFieldErrorMeg("Invalid Phone Number")
                isValid = 0;
            }else
            {
                setErrorOnPhoneField(false)
                setPhoneFieldErrorMeg("")
                isValid = 1;
            }
        }

        return isValid;
    }

    let customersListFetchTimer = null;
    const onCustomerNumberSearchChange = (e, data) => {
        let value = format(data.value);
        setCustomerSearchQuery(value)
        validatePhoneField(value);
        if(customersListFetchTimer)
        {
            clearTimeout(customersListFetchTimer)
        }
        customersListFetchTimer = setTimeout(() => {
            if(data.value && data.value.length > 3)
            {
                getSellerCustomerSearch({
                    cellPhone : normalize(data.value)
                }).then((res) => {
                    let searchResult = [];
                    if(res.resStatus == 200)
                    {
                        setCustomerData(res.data)
                        searchResult = res.data.map((cus) => {
                            return {id : cus.sellerCustomerID , title : `${cus.first} - ${format(cus.cellPhone)}`}
                        });

                        if(data.value.length == 14 &&  res.data.length == 0)
                        {
                            searchResult = [{id: -1, title: "Add Customer"}, ...searchResult]
                        }
                    }else
                    {
                        if(data.value.length == 14)
                        {
                            searchResult = [{id: -1, title: "Add Customer"}]
                        }
                    }

                    setCustomerSearchResult(searchResult);
                })
            }
        }, 500);
    }  

    const onResultSelect = (e,data) => {
    
        if(data.result && data.result.id)
        {
            if( data.result.id == -1){
                // Add new customer case
                setCustomerSearchQuery(format(data.value));
                setSelectedCustomerId(undefined);
                validatePhoneField(data.value);
                setCustomerSelected(true);
            }else
            {
                let selectedCustomer = customerData.filter((cus) => {
                    return cus.sellerCustomerID == data.result.id
                });
    
                setCustomerSearchQuery(format(selectedCustomer[0].cellPhone));
                // setCustomerName(selectedCustomer[0].first + " " + selectedCustomer[0].last)
                setSelectedCustomerId(data.result.id)
                validatePhoneField(selectedCustomer[0].cellPhone);
                setCustomerSelected(true);
            }
        }
    }

    // const handleCustomerNameChange = (e) => {
    //     setCustomerName(e.target.value);
    // }

    const resetForm = () => {
        setCustomerSearchQuery("")
        setSelectedCustomerId(undefined)
        setSelectedServiceState(undefined)
        // setCustomerName("")
        // setCustomerNameKey(customerNameKey + 1)
        setCustomerSelected(false);
    }

    const clearCustomerSelection = () => {
        setCustomerSearchQuery("")
        setSelectedCustomerId(undefined)
        // setCustomerName("")
        // setCustomerNameKey(customerNameKey + 1)
        setCustomerSelected(false);
    }
    const clearServiceSelection = () => {

        setSelectedServiceState(undefined);
    }
    const redirectToHomePage = () => {
      history.push(NavigationUrls.CUSTOMER_REQUESTS_LIST);  
    }

  return (
    <div className='page create-customer-request-container'>
        <div className='main-div'>
            <div className='page-title'>
                <div onClick={() => {redirectToHomePage()}}  className={"home-icon-container"}>
                    <svg className={"home-icon"} xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41">
                        <defs>
                            <clipPath id="clip-path">
                            <rect id="Rectangle_9028" data-name="Rectangle 9028" width="21.679" height="20.981" transform="translate(0 0)" fill="#5d79e7"/>
                            </clipPath>
                        </defs>
                        <g id="Group_16409" data-name="Group 16409" transform="translate(-15 -102)">
                            <g id="Group_16407" data-name="Group 16407" transform="translate(-100 -49)">
                            <g id="Group_16370" data-name="Group 16370" transform="translate(100 49)">
                                <rect id="Rectangle_9022" data-name="Rectangle 9022" width="41" height="41" rx="13" transform="translate(15 102)" fill="#ebf2fe"/>
                            </g>
                            </g>
                            <g id="Group_16408" data-name="Group 16408" transform="translate(25 112)">
                            <g id="Group_16404" data-name="Group 16404" transform="translate(0 0)" clip-path="url(#clip-path)">
                                <path id="Path_42133" data-name="Path 42133" d="M10.938,4.323c-.131.087-.248.161-.361.24C8.26,6.18,5.948,7.8,3.623,9.409a.853.853,0,0,0-.414.8c.013,3.42.007,6.841.009,10.261,0,.166.014.333.022.505H8.818V15.813h4v5.169H18.6a1.288,1.288,0,0,0,.026-.169c0-3.608.006-7.216-.009-10.824a.7.7,0,0,0-.272-.474c-.741-.546-1.5-1.065-2.257-1.593l-5.149-3.6M10.91,2.612c.689.489,1.363.965,2.036,1.444Q16.379,6.5,19.812,8.938A1.062,1.062,0,0,0,21.154,9a1.188,1.188,0,0,0,.452-1.368,1.934,1.934,0,0,0-.635-.769Q16.487,3.635,11.979.443a1.321,1.321,0,0,0-1.973,0Q5.3,3.8.6,7.167A1.221,1.221,0,0,0,.23,8.922c.4.558,1,.606,1.681.123Q3.933,7.606,5.948,6.16L10.91,2.612" transform="translate(0 0)" fill="#5d79e7"/>
                                <path id="Path_42134" data-name="Path 42134" d="M24.844,23.062l5.149,3.6c.755.528,1.516,1.047,2.257,1.593a.7.7,0,0,1,.272.473c.015,3.608.01,7.216.009,10.824a1.283,1.283,0,0,1-.026.169H26.725V34.552h-4v5.165H17.146c-.008-.172-.022-.339-.022-.505,0-3.42,0-6.841-.009-10.261a.853.853,0,0,1,.414-.8c2.325-1.6,4.637-3.229,6.954-4.846.113-.079.231-.153.361-.24" transform="translate(-13.907 -18.739)" fill="#5d79e7"/>
                                <path id="Path_42135" data-name="Path 42135" d="M10.91,2.612,5.948,6.16Q3.93,7.6,1.911,9.044C1.232,9.528.631,9.48.23,8.922A1.221,1.221,0,0,1,.6,7.167Q5.3,3.8,10.006.442a1.321,1.321,0,0,1,1.973,0q4.5,3.2,8.991,6.418a1.934,1.934,0,0,1,.635.769A1.188,1.188,0,0,1,21.154,9a1.062,1.062,0,0,1-1.341-.06Q16.376,6.5,12.946,4.056C12.274,3.577,11.6,3.1,10.91,2.612" transform="translate(0 0)" fill="#5d79e7"/>
                            </g>
                            </g>
                        </g>
                    </svg>
                </div> 
                <h1>Customer Request</h1></div>
                <br></br>

              <Formsy onValidSubmit={onSubmit} onInvalidSubmit={onInvalidSubmit} ref={formRef}>
                  <Grid className='form-grid'>
                      <Grid.Row columns={1}>               
                          <Grid.Column computer={16} mobile={16}>
                                
                                {
                                  customerSelected ? <div className={"customer-info-label"}>
                                    <span>
                                        <b>Phone :</b> {customerSearchQuery}
                                    </span>
                                    
                                    <Icon 
                                        size={"large"}
                                        onClick={(e) => {clearCustomerSelection()}}
                                        className="close-icon" 
                                        name="close"/> 
                                  </div>  : 
                                    <div className="customer-search-field">     
                                        <Search
                                            minCharacters={4}
                                            onSearchChange={onCustomerNumberSearchChange}
                                            onKeyDown={onPhoneKeyDown}
                                            results={customerSearchResult}
                                            maxLength={14}
                                            placeholder={"Customer Phone"}
                                            onResultSelect={onResultSelect}
                                            value={customerSearchQuery}
                                            className={`customer-number-autofill ${errorOnPhoneField ? "error" : ""}`}
                                            disabled={customerSelected}
                                            ></Search>
                                            {errorOnPhoneField &&
                                                <div className="error-label" >
                                                    {phoneFieldErrorMeg}
                                                </div>
                                            }  
                                    </div> 
                                }
                          </Grid.Column>
                          {/* <Grid.Column computer={1} mobile={2}>
                              {
                                  customerSelected ? 
                                    <Icon 
                                        size={"large"}
                                        onClick={(e) => {clearCustomerSelection()}}
                                        className="close-icon" 
                                        name="close"/> 
                                    : ""
                              }
                          </Grid.Column>  */}
                      </Grid.Row>
                      <Grid.Row columns={1}>
                        {/* <Grid.Column computer={8} mobile={16}>
                              <DGTextbox
                                  key={customerNameKey}
                                  tabIndex={1}
                                  name="name" 
                                  label="Customer Name" 
                                  //   required
                                  maxLength={100}
                                //   validationErrors={{
                                //       isDefaultRequiredValue: 'Customer Name is required',
                                //       isNotBlankString: `Customer Name is required`,

                                //   }}
                                  onChange={(e) => handleCustomerNameChange(e)}
                                //   validations={{
                                //       isNotBlankString: true
                                //   }}
                                  value={customerName || undefined}
                                  disabled={selectedCustomerId}
                              />
                        </Grid.Column> */}
                        <Grid.Column computer={16} mobile={16}>

                            {
                                selectedServiceState ?  <div className={"customer-info-label"}>
                                <span>
                                    <b>Service :</b> {servicesOptionState.find((item) => {return item.value == selectedServiceState })?.text}
                                </span>
                                
                                <Icon 
                                    size={"large"}
                                    onClick={(e) => {clearServiceSelection()}}
                                    className="close-icon" 
                                    name="close" /> 
                                </div> 
                              :
                                <>
                               
                                <Form.Dropdown
                                        selectOnBlur={false}
                                        tabIndex={4}
                                        name="serviceID"
                                        placeholder="Select Service"
                                        selection
                                        required
                                        fluid
                                        className="multi-select service-dropdown"
                                        validationErrors={{
                                            isDefaultRequiredValue: 'Service is required',
                                        }}
                                        onChange={handleServiceSelection}
                                        label="Service"
                                        options={servicesOptionState}
                                        value={selectedServiceState || ""}
                                        error={errorOnServiceSelection ? true : false}
                                    />
                                    {errorOnServiceSelection &&
                                        <div className="error-label" >
                                            Service is required
                                        </div>
                                    }  
                                </>
                            }       
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row columns={1} className="btn-row">
                          <Grid.Column className={"btn-container"}>
                              <Button primary disabled={!customerSelected || !selectedServiceState} 
                                type='submit' className='continue-btn'>Continue</Button>
                          </Grid.Column>
                      </Grid.Row>
                  </Grid>
              </Formsy>

        </div>
          {showLoader ? <Dimmer active>
              <Loader indeterminate size='massive' />
          </Dimmer> : ''}

    </div>
  )
}

export default withRouter(CreateCustomerRequestContainer);